export const normalizeServiceBranchIds = (service) => {
  if (!service) return null;

  const ids = service.branchIds;
  if (Array.isArray(ids) && ids.length > 0) {
    return ids.map((id) => String(id._id || id));
  }

  const legacy = service.branchId;
  if (legacy) return [String(legacy._id || legacy)];

  return null;
};

export const serviceAvailableAtBranch = (service, branchId) => {
  if (!service || !branchId) return false;
  const ids = normalizeServiceBranchIds(service);
  if (!ids) return true;
  return ids.includes(String(branchId));
};

export const formatServiceBranchLabel = (service, branches, allBranchesLabel) => {
  const ids = normalizeServiceBranchIds(service);
  if (!ids) return allBranchesLabel;
  const names = ids
    .map((id) => branches.find((b) => String(b._id) === id)?.name)
    .filter(Boolean);
  return names.length ? names.join(', ') : allBranchesLabel;
};

export const resolveBookBranchId = (service, preferredBranchId) => {
  const ids = normalizeServiceBranchIds(service);
  if (!ids) return preferredBranchId || '';
  if (preferredBranchId && ids.includes(String(preferredBranchId))) return preferredBranchId;
  return ids[0] || '';
};
